import { html } from 'lit';
export const iconCopy = html`
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M5.6875 0.75H9.07812C9.40625 0.75 9.76172 0.914062 10.0078 1.16016L11.8398 2.99219C12.0859 3.23828 12.25 3.59375 12.25 3.92188V9.9375C12.25 10.6758 11.6484 11.25 10.9375 11.25H5.6875C4.94922 11.25 4.375 10.6758 4.375 9.9375V2.0625C4.375 1.35156 4.94922 0.75 5.6875 0.75ZM1.3125 4.25H3.5V6H1.75V13H7V12.125H8.75V13.4375C8.75 14.1758 8.14844 14.75 7.4375 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V5.5625C0 4.85156 0.574219 4.25 1.3125 4.25Z"
    />
  </svg>
`;
